import type { DomSanitizer } from '@angular/platform-browser';

import { pipe } from 'rxjs';

import {
  ReportDashboardComponentKind,
  ReportsTranslations,
  VisualizationMapperOperator,
  Blueprint,
} from '@core/reports-types';
import type { DurationPipe } from '@core/user-interface-legacy';

import { funnelBarChartBlueprint } from './strategies/funnel/bar';
import { funnelPieChartBlueprint } from './strategies/funnel/pie';
import { funnelSummaryBlueprint } from './strategies/funnel/summary';
import { funnelTableBlueprint } from './strategies/funnel/table';
import { filterByMetricKind, fromBlueprints } from './strategies/operators';

export const funnelBlueprints = (
  sanitizer: DomSanitizer,
  translations: ReportsTranslations,
  durationPipe: DurationPipe,
): Array<Blueprint<any>> => [
  funnelBarChartBlueprint(translations, durationPipe),
  funnelPieChartBlueprint(translations, durationPipe),
  funnelSummaryBlueprint(translations),
  funnelTableBlueprint(translations.i18n),
];

export const funnel = (
  sanitizer: DomSanitizer,
  translations: ReportsTranslations,
  durationPipe: DurationPipe,
): VisualizationMapperOperator =>
  pipe(
    filterByMetricKind(ReportDashboardComponentKind.Funnel),
    fromBlueprints(funnelBlueprints(sanitizer, translations, durationPipe)),
  );
